import { Container } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import ProjectDataTable from "./ProjectDataTable";

export default function ProjectFinder(props) {
    const { projects } = useOutletContext();

    return (
        <Container>
            <ProjectDataTable dataResult={projects} />
        </Container>
    );
}
